/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { useQuery } from '@apollo/client';

import {
  UserDefaultTeamIdDocument,
  UserIdDocument,
  UserIdentityTypeDocument,
  UserInfoWithEmailDocument,
} from '@fai/friendli-suite/generated/client/graphql';

const useUserId = () => {
  const { data: rawData, loading } = useQuery(UserIdDocument);

  const data = rawData?.clientSession?.user.id;

  return { data, loading };
};

const useUserDefaultTeamId = () => {
  const { data: rawData, loading } = useQuery(UserDefaultTeamIdDocument);

  const data = rawData?.clientSession?.user.teamDefault?.team.id;

  return { data, loading };
};

const useUserInfoWithEmail = () => {
  const { data: rawData, loading } = useQuery(UserInfoWithEmailDocument);

  const data = rawData?.clientSession?.user;

  return { data, loading };
};

const useUserIdentityType = () => {
  const { data, loading } = useQuery(UserIdentityTypeDocument);

  const identityType = data?.clientSession?.user.identityType;

  return { identityType, loading };
};

export { useUserId, useUserDefaultTeamId, useUserInfoWithEmail, useUserIdentityType };
